<div class="form" *appTaskingAppContext>
  <div class="form-date">{{ task?.createdAt | dateFormat: 'date' }}</div>

  <h2 class="form-title">
    <app-icon class="form-heading-title-icon" name="project" [style.color]="task?.color" />
    {{ task?.title }}
  </h2>

  @if (task) {
    <app-shared-tags class="form-tags" [stitchItem]="task" [stateKey]="StateKey.tagsList" />

    <app-shared-knots class="form-knots" [stitchItem]="task" [stateKey]="StateKey.knotsList" />
  }

  <app-shared-signup-cta />

  <div class="form-details">
    <div class="form-details-row">
      <div class="form-details-row-title">Parent Task</div>
      <div class="form-details-row-input">{{ task?.parentId }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Project</div>
      <div class="form-details-row-input">{{ task?.projectId }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Description</div>
      <stch-item-description class="form-details-row-input" stchHighlightText [html]="task?.description" />
    </div>

    <!--This section is hidden for V1-->
    @if (false) {
      <div class="form-details-row">
        <div class="form-details-row-title">Issue Key Title</div>
        <div class="form-details-row-input">{{ task | taskIssueKeyTitle }}</div>
      </div>
    }

    <div class="form-details-row">
      <div class="form-details-row-title">From Date</div>
      <div class="form-details-row-input">{{ task?.startDateTime | dateFormat: 'dateTime' : undefined : true : (task | stitchDateZone: 'start') }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">To Date</div>
      <div class="form-details-row-input">{{ task?.endDateTime | dateFormat: 'dateTime' : undefined : true : (task | stitchDateZone: 'end') }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Priority</div>
      <div class="form-details-row-input">{{ task?.priority }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Assignee</div>
      <div class="form-details-row-input">{{ task?.assigneeId }}</div>
    </div>
  </div>
</div>
